export const CAMP_LIST_REQUEST="CAMP_LIST_REQUEST"
export const CAMP_LIST_SUCCESS="CAMP_LIST_SUCCESS"
export const CAMP_LIST_FAIL="CAMP_LIST_FAIL"
export const CAMPNAME_LIST_REQUEST="CAMPNAME_LIST_REQUEST"
export const CAMPNAME_LIST_SUCCESS="CAMPNAME_LIST_SUCCESS"
export const CAMPNAME_LIST_FAIL="CAMPNAME_LIST_FAIL"
